import { Typography } from 'mobily-ui-library/lib'
import { useTranslation } from 'react-i18next';
import './StoreMapPopup.scss';

const StoreMapPopup = ({ places, status, time, type, id, rtl, mode }: any) => {
    const { t } = useTranslation();

    return (
        <div className={rtl ? 'MapPopup__container Map_arabic' : 'MapPopup__container'}>
            {type === 'currentLocation' ? (
                <Typography className='MPU__text'><span>{t('current_location')}</span></Typography>
            ) : (

                <Typography className='MPU__text'>{time} <span>{status}</span></Typography>
            )}
            <Typography className='MPU__place'>{places}</Typography>
            {type === 'Store' && <button id={`mpuButton${id}`} className='MPU__button' style={{ display: mode ? 'none' : "block" }}>{t("get_directions")}</button>}
        </div>
    )
}


export default StoreMapPopup;